import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Service1244 from '../1244';
import Service1343 from '../1343';
import Service1333 from '../1333';
import Service1327 from '../1327';
import Service1342 from '../1342';
import Service1255 from '../1255';
import Service1340 from '../1340';
import Service1259 from '../1259';
import FreeToGuest from '../FTG';
import Requests from '../Requests';
import Service1274 from '../1274';
import Service6541 from '../6541';
import Staycast from '../Staycast';
import Service1240 from '../1240';
import Service1278 from '../1278';
import Service1260 from '../1260';
import PatientGuide from '../PatientGuide';
import Service1210 from '../1210';
import WelcomeVIW from '../1060';
import Service1203 from '../1203';
import Service1230 from '../1230';
import Spiritual1230 from '../1230_spiritual';
import Service1277 from '../1277';
import Service1101 from '../1101';
import StepTracker from '../6543';
import Service1350 from '../1350';
import PatientPortalSignup from '../PatientPortalSignup';
import Service1346 from '../1346';
import Service1361 from '../1361';
import Service1364 from '../1364';
import DWB from '../DWB';

class Routes extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/main_menu" component={Service1101} />{' '}
        <Route path="/assigned_education" component={Service1244} />{' '}
        <Route path="/education_library" component={Service1255} />{' '}
        <Route path="/info_confirmation/allergies" component={Service1343} />{' '}
        <Route path="/info_confirmation/meds" component={Service1343} />{' '}
        <Route path="/pain_monitoring" component={Service1333} />{' '}
        <Route path="/discharge_checklist" component={Service1342} />{' '}
        <Route path="/environmental_controls" component={Service1327} />{' '}
        <Route path="/medication_education" component={Service1340} />{' '}
        <Route path="/ftg/:channelName" component={FreeToGuest} />{' '}
        <Route path="/scheduled_procedures" component={Service1259} />{' '}
        <Route path="/care_team" component={Service1274} />{' '}
        <Route path="/pharmacy" component={Service6541} />{' '}
        <Route path="/staycast" component={Staycast} />{' '}
        <Route path="/languages" component={Service1240} />{' '}
        <Route path="/ipg" component={Service1278} />{' '}
        <Route path="/requests" component={Requests} />{' '}
        <Route path="/sleep_timer" component={Service1260} />{' '}
        <Route path="/patient_guide" component={PatientGuide} />{' '}
        <Route path="/feedback" component={Service1210} />{' '}
        <Route path="/welcome" component={WelcomeVIW} />{' '}
        <Route path="/movies" component={Service1203} />{' '}
        <Route path="/assigned_education/prompts" component={Service1244} />{' '}
        <Route path="/music" component={Service1230} />{' '}
        <Route path="/spiritual" component={Spiritual1230} />{' '}
        <Route path="/room_service" component={Service1277} />{' '}
        <Route path="/step_tracker" component={StepTracker} />{' '}
        <Route path="/retail_shopping" component={Service1350} />{' '}
        <Route path="/patient_portal_signup" component={PatientPortalSignup} />{' '}
        <Route path="/dwb_controls" component={Service1346} />{' '}
        <Route path="/messages" component={Service1361} />{' '}
        <Route path="/telehealth" component={Service1364} />{' '}
        <Route path="/dwb" component={DWB} />{' '}
        <Redirect to="/main_menu/mydashboard" />
      </Switch>
    );
  }
}

export default withRouter(Routes);
